import(/* webpackMode: "eager" */ "/opt/render/project/src/app/page.js");
